import React from 'react'
import PropTypes from 'prop-types'
import Media from 'components/common/Media'
import Link from 'components/common/Link/Link'
import HTMLContainer from 'components/common/HTMLContainer/HTMLContainer'
import styled from 'styled-components'

const Promotion = ({
  promotionHTML,
  promotionLinkUrl,
  promotionTitle,
  promoImageContent
}) =>
  <Wrapper>
    {
      promotionHTML ?
        <HTMLContainer content={ promotionHTML } /> :
        <Link to={ promotionLinkUrl }>
          <Media.Desktop>
            <Banner src={ `${promoImageContent}?$BOT-TireSearchResult-Promotion-Desktop-w1182$` } alt={ promotionTitle } />
          </Media.Desktop>
          <Media.Mobile>
            <Banner src={ `${promoImageContent}?$BOT-TireSearchResult-Promotion-Desktop-w989$` } alt={ promotionTitle } />
          </Media.Mobile>
        </Link>
    }
  </Wrapper>

Promotion.propTypes = {
  promoImageContent: PropTypes.string,
  promotionHTML: PropTypes.string,
  promotionLinkUrl: PropTypes.string,
  promotionTitle: PropTypes.string
}

export default Promotion

const Wrapper = styled.div`
  display: block;
  width: 100%;
  position: relative;
`

const Banner = styled.img`
  display: block;
  width: 100%;
`
